import { render, staticRenderFns } from "./BigImg.vue?vue&type=template&id=0fb08651&scoped=true&"
import script from "./BigImg.vue?vue&type=script&lang=js&"
export * from "./BigImg.vue?vue&type=script&lang=js&"
import style0 from "./BigImg.vue?vue&type=style&index=0&id=0fb08651&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb08651",
  null
  
)

export default component.exports